var _defs, _path, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDashboardBig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Level_Icons",
    "data-name": "Level Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75.884,
    height: 75.884,
    viewBox: "0 0 75.884 75.884",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#434a60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a7791"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5689",
    "data-name": "Path 5689",
    d: "M37.942,0A37.942,37.942,0,1,1,0,37.942,37.942,37.942,0,0,1,37.942,0Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1815",
    "data-name": "Rectangle 1815",
    width: 41,
    height: 41,
    transform: "translate(17.885 17.001)",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4080",
    "data-name": "Group 4080",
    transform: "translate(22.275 21.388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6036",
    "data-name": "Path 6036",
    d: "M22.717,13.585H18.758A5.194,5.194,0,0,1,13.57,8.4V4.438A5.188,5.188,0,0,1,18.758-.75h3.959a5.194,5.194,0,0,1,5.188,5.188V8.4A5.194,5.194,0,0,1,22.717,13.585ZM18.758,1.707a2.731,2.731,0,0,0-2.731,2.731V8.4a2.734,2.734,0,0,0,2.731,2.731h3.959A2.734,2.734,0,0,0,25.448,8.4V4.438a2.734,2.734,0,0,0-2.731-2.731Z",
    transform: "translate(4.26 0.75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6037",
    "data-name": "Path 6037",
    d: "M8.409,13.585H4.438A5.194,5.194,0,0,1-.75,8.4V4.438A5.188,5.188,0,0,1,4.438-.75H8.393a5.188,5.188,0,0,1,5.2,5.188V8.4a5.188,5.188,0,0,1-5.188,5.188ZM4.438,1.707A2.731,2.731,0,0,0,1.707,4.438V8.4a2.734,2.734,0,0,0,2.731,2.731H8.4A2.731,2.731,0,0,0,11.141,8.4V4.438A2.731,2.731,0,0,0,8.4,1.707L8.4.478V1.707Z",
    transform: "translate(0.75 0.75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6039",
    "data-name": "Path 6039",
    d: "M22.717,27.905H18.758a5.194,5.194,0,0,1-5.188-5.188V18.758a5.188,5.188,0,0,1,5.188-5.188h3.959a5.194,5.194,0,0,1,5.188,5.188v3.959A5.194,5.194,0,0,1,22.717,27.905ZM18.758,16.027a2.731,2.731,0,0,0-2.731,2.731v3.959a2.734,2.734,0,0,0,2.731,2.731h3.959a2.734,2.734,0,0,0,2.731-2.731V18.758a2.734,2.734,0,0,0-2.731-2.731Z",
    transform: "translate(4.26 4.26)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6040",
    "data-name": "Path 6040",
    d: "M8.409,27.905H4.438A5.194,5.194,0,0,1-.75,22.717V18.758A5.188,5.188,0,0,1,4.438,13.57H8.4a5.188,5.188,0,0,1,5.2,5.188v3.959a5.188,5.188,0,0,1-5.188,5.188ZM4.438,16.027a2.731,2.731,0,0,0-2.731,2.731v3.959a2.734,2.734,0,0,0,2.731,2.731H8.4a2.731,2.731,0,0,0,2.744-2.731V18.758A2.731,2.731,0,0,0,8.4,16.027l0-1.228v1.228Z",
    transform: "translate(0.75 4.26)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboardBig);
export default __webpack_public_path__ + "static/media/icon_dashboard_big.5e1217d6ffbcaa8a89bdfafb92b92b5b.svg";
export { ForwardRef as ReactComponent };